import axios from '../axios';
// 教育经历 列表
export const getBaseEmployeeEducationPage = data => {
    return axios({
        url: '/api/sys/base/getBaseEmployeeEducationPage',
        method: 'post',
        data
    })
};
// 教育经历 保存
export const saveBaseEmployeeEducation = data => {
    return axios({
        url: '/api/sys/base/saveBaseEmployeeEducation',
        method: 'post',
        data
    })
};
// 教育经历 修改
export const updateBaseEmployeeEducation = data => {
    return axios({
        url: '/api/sys/base/updateBaseEmployeeEducation',
        method: 'post',
        data
    })
};
// 教育经历 删除
export const deleteBaseEmployeeEducations = data => {
    return axios({
        url: '/api/sys/base/deleteBaseEmployeeEducations',
        method: 'post',
        data
    })
};


// WEBPACK FOOTER //
// ./src/api/moudules/education.js